import React from 'react';
import CheckIcon from '../Icons/Video/CheckIcon';
import { T } from '@tolgee/react';

interface RegisteredMessageProps {
  isDark?: boolean;
}

const RegisteredMessage: React.FC<RegisteredMessageProps> = ({ isDark = false }) => {
  return (
    <div className="text-base leading-tight flex items-center whitespace-nowrap">
      <CheckIcon fill={isDark ? 'white' : 'black'} />
      <span className="ml-5">
        <T>live_classes.live_class_details.youre_registered.tag.label</T>
      </span>
    </div>
  );
};

export default RegisteredMessage;
